<template>
    <div class="record_main">
      <!--商品信息-->
      <div class="gx-sd__card">
        <div class="gx-sd__card-img">
          <img :src="productInfo.img" style="width:90px;height: 90px">
        </div>
        <div class="gx-sd__goods">
          <div class="gx-sd__goods-title">{{ productInfo.name }}</div>
          <div class="gx-sd__goods-info">
            <span class="gx-sd__goods-price">¥{{productInfo.origin_discount_price }}</span>
            <span class="gx-sd__goods-label--153">销售额</span>
            <span style="font-size: 13px; color: rgb(82, 196, 26); font-weight: 600;">{{productInfo.profit_rate?productInfo.profit_rate+'%':'--'}}</span>
            <span class="gx-sd__goods-label--153">毛利率</span>
            <span class="gx-sd__goods-line"></span>
            <span class="gx-sd__goods-label--102">店铺名称：</span>
            <span style="font-size: 12px; color: rgb(26, 26, 46); font-weight: 500;">{{ productInfo.shop_name ||'--' }}</span>
            <span class="gx-sd__goods-label--102">商品ID：</span>
            <span style="font-size: 12px; color: rgb(153, 153, 153);">{{productInfo.outer_product_id}}</span></div>
        </div>
        <div class="gx-sd__opts">
          <button class="gx-sd__opts-btn gx-sd__opts-btn--info" @click="copyText(productInfo.outer_product_id)">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><rect x="1" y="3" width="7" height="8" rx="1.5" stroke="currentColor" stroke-width="1.2"></rect><path d="M4 1h6a1 1 0 011 1v8" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"></path></svg>
            复制
          </button>
          <button class="gx-sd__opts-btn gx-sd__opts-btn--danger" @click="$emit('back')">← 返回列表</button></div>
      </div>

      <!-- 利润看板 -->
      <div class="gx-sd__board" >
        <div class="gx-sd__board-head">
         利润看板
        </div>
        <div class="gx-sd__board-body">
          <div v-for="(grp, gi) in activeStatGroups" :key="grp.title" class="gx-sd__grp">
            <div class="gx-sd__grp-head">
              <span class="gx-sd__grp-bar" :style="{ background: grp.bar }"></span>
              <span class="gx-sd__grp-title">{{ grp.title }}</span>
              <span class="gx-sd__grp-desc">— {{ grp.desc }}</span>
            </div>
            <div class="gx-sd__grp-items" :style="{ gridTemplateColumns: grp.last ? 'repeat(3,1fr)' : 'repeat(10,1fr)' }">
              <div
                  v-for="(s, si) in grp.items"
                  :key="si"
                  class="gx-sd__item"
                  :class="{ 'gx-sd__item--last': grp.last, 'gx-sd__item--key': isKey(s.label) }"
              >
                <div class="gx-sd__item-label">{{ s.label }}</div>
                <div class="gx-sd__item-value">{{ summary?.[s.key]?.val??'--' }}</div>
<!--                <div class="gx-sd__item-mom">
                  <span v-if="s.up === true" class="gx-sd__mom-arrow">▲</span>
                  <span v-if="s.up === false" class="gx-sd__mom-arrow gx-sd__mom-arrow&#45;&#45;down">▼</span>
                  <span>月环比 {{ s.mom }}</span>
                </div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--筛选-->
      <div class="gx-sd__filter custom-form-wrap">
        <el-form inline size="mini">
          <el-form-item label="付款时间">
            <el-date-picker
                v-model="selectDay"
                end-placeholder="结束日期"
                range-separator="-"
                size="mini"
                start-placeholder="开始日期"
                type="daterange"
                value-format="yyyy-MM-dd"
                style="width: 200px"
                @change="changeDate">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="用户名">
            <el-select v-model="selectBusiness" filterable placeholder="请选择或输入" @change="changeBusiness">
              <el-option v-for="item in businessList" :key="item.id" :label="item.nickname" :value="item.id">  </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="店铺名">
            <el-select v-model="selectShop" filterable placeholder="请选择或输入" @change="changeShop">
              <el-option v-for="item in shopList" :key="item.id" :label="item.shop_name" :value="item.shop_id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 排行表 -->
      <div class="gx-sd__rank custom-el-wrapper">
        <div class="gx-sd__rank-search">
          <div class="gx-sd__rank-tabs">
            <button
                v-for="t in rankTabs"
                :key="t.id"
                class="gx-sd__rank-tab"
                :class="{ 'gx-sd__rank-tab--on': rankTab === t.id }"
                @click="switchRank(t.id)"
            >{{ t.label }}</button>
          </div>

        </div>
        <div class="gx-sd__ran-filter custom-form-wrap">
          <el-form inline size="mini" style="width: 100%">
            <el-form-item class="btns">
              <button type="button" class="btn btn-config" @click="openConfig">
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><circle cx="6" cy="6" r="2" stroke="currentColor" stroke-width="1.2"></circle><path d="M6 1v1.5M6 9.5V11M1 6h1.5M9.5 6H11M2.4 2.4l1 1M8.6 8.6l1 1M9.6 2.4l-1 1M3.4 8.6l-1 1" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"></path></svg>
                数据配置
                <span class="column-Num">{{columnNum}}</span>
              </button>
            </el-form-item>
          </el-form>
        </div>

        <!-- 店铺排行 -->
        <div v-if="rankTab === 'shop'" class="gx-sd__table">
          <table>
            <thead>
            <tr>
              <th v-for="(h,i) in shopRankCols" :key="i">{{ h.label }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="r in shopRank" :key="r.shop_id || r.ranking">
              <td class="gx-sd__mono" v-for="(h,i) in shopRankCols" :key="i">
                <template v-if="h.key==='ranking'">
                  <span class="gx-sd__rank-no gx-sd__rank-no--one" v-if="r.ranking==1||r.scope==1">👑</span>
                  <span class="gx-sd__rank-no gx-sd__rank-no--two" v-else-if="r.ranking==2||r.scope==2">👁️</span>
                  <span class="gx-sd__rank-no gx-sd__rank-no--three" v-else-if="r.ranking==3||r.scope==3">3</span>
                  <span class="gx-sd__rank-no" v-else>{{ r.ranking || r.scope || '--' }}</span>
                </template>
                <template v-else-if="h.key==='shop_name'">
                  <div class="gx-sd__shop-name">
                    <div class="gx-sd__shop-name-icon" v-if="r.shop_name">{{r.shop_name[0]}}</div>
                    <span>{{ r.shop_name || '--' }}</span>
                  </div>
                </template>
                <template v-else-if="h.key==='all_sales'">
                  <span class="gx-sd__red">{{ r.all_sales || '--' }}</span>
                </template>
                <template v-else-if="h.key==='all_total_profit'">
                  <span :class="Number(r.all_total_profit)<0?'gx-sd__red':'gx-sd__green'">{{ r.all_total_profit || '--' }}</span>
                </template>
                <template v-else>
                  {{ [h.key]?r[h.key]: '--' }}
                </template>
              </td>
            </tr>
            <tr v-if="!shopRank.length">
              <td :colspan="shopRankCols.length" class="gx-sd__empty">暂无排行数据</td>
            </tr>
            </tbody>
          </table>
        </div>

        <!-- 明细数据 -->
        <div v-else class="gx-sd__table">
          <table>
            <thead>
            <tr>
              <th v-for="(h,i) in detailsRankCols" :key="i">{{ h.label }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(r ,index) in productList" :key="index">
              <td class="gx-sd__mono" v-for="(h,i) in detailsRankCols" :key="i">
                <template v-if="h.dKey==='index'">
                <span style="color: #999999">{{ index+1 }}</span>
                </template>
                <template v-else-if="h.dKey==='total_profit'">
                  <span :class="Number(r.total_profit)<0?'gx-sd__red':'gx-sd__green'">{{ r.total_profit || '--' }}</span>
                </template>
                <template v-else-if="h.dKey==='profit_rate'">
                  <span :class="Number(r.profit_rate)<0?'gx-sd__red':'gx-sd__green'">{{ r.profit_rate?r.refund_rate+'%' : '--' }}</span>
                </template>
                <template v-else-if="h?.dKey?.indexOf('_rate')>-1">
                  {{ [h.dKey]? displayRate(r[h.dKey]): '--' }}
                </template>
                <template v-else>
                  {{ [h.dKey]? displayValue(r[h.dKey]): '--' }}
                </template>
              </td>
            </tr>
            <tr v-if="!productList.length">
              <td :colspan="detailsRankCols.length" class="gx-sd__empty">暂无排行数据</td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="gx-sd__pager">
          <span class="gx-sd__pager-total">共 {{ page_data.total }} 条 · {{page_data.limit}}条/页</span>
          <div class="gx-sd__pager-btns">
            <button class="gx-sd__page" :disabled="page_data.page <= 1" @click="loadRank(page_data.page - 1)">‹</button>
            <button v-for="n in pageNums" :key="n" class="gx-sd__page" :class="{ 'gx-sd__page--on': n === page_data.page }" @click="loadRank(n)">{{ n }}</button>
            <button class="gx-sd__page" :disabled="page_data.page >= totalPages" @click="loadRank(page_data.page + 1)">›</button>
          </div>
        </div>
      </div>

      <column-config-dialog ref="columnConfigRef" :column-groups="rankColumnGroups" :current-column-config="columnConfig" @change="changeColumnConfig($event)"></column-config-dialog>
    </div>

</template>
<script>

import {mapActions, mapState} from "vuex";
import ColumnConfigDialog from "@/pages/shopData/ColumnConfig.vue";

const rankColumnGroups = [
  {
    title: '营收 & 采购大盘',
    color: '#1677ff',
    fields: [
      { label: '营业额', key: 'all_sales',dKey:'sale'},
      { label: '订单量', key: 'all_sales_orders',dKey:'sales_orders' },
      { label: '采购量', key: 'all_purchase',dKey: 'purchase_amount' },
      { label: '采购应收', key: 'all_purchase_order_amount' },
      { label: '采购应付', key: 'all_purchase_amount' },
      { label: '发货量', key: 'all_shipping_num' },
      { label: '代发费', key: 'all_shipping_fee' },
      { label: '达人佣金', key: 'all_influencer_commission' },
      { label: '权益保险', key: 'all_shipping_insurance' },
      { label: '千川费用', key: 'all_qianchuan_fee' },
    ]
  },
  {
    title: '售后退款类',
    color: '#52c41a',
    fields: [
      { label: '总退货率', key: 'all_return_rate' },
      { label: '发货前仅退货率', key: 'all_refund_only_rate' },
      { label: '发货后退货率', key: 'all_after_refund_rate' },
      { label: '全部退货量', key: 'all_refund_num' },
      { label: '发货前仅退货量', key: 'all_refund_only_num' },
      { label: '发货后退货量', key: 'all_after_refund_num' },
      { label: '发货前仅退款金额', key: 'all_refund_only_amount' },
      { label: '发货后退货金额', key: 'all_refund_fee' },
      { label: '换货订单量', key: 'all_exchange_order_num' },
      { label: '待上游退款金额', key: 'all_wait_refund_amount' },
    ]
  },
  {
    title: '平台费用 & 赔付杂费',
    color: '#fa8c16',
    fields: [
      { label: '平台服务费', key: 'all_shop_service_fee' },
      { label: '消费者赔付', key: 'all_timeout_compensation' },
      { label: '判罚扣款', key: 'all_violation_compensation' },
      { label: '评价有礼', key: 'all_evaluate_fee' },
      { label: '上门取件运费', key: 'all_pick_up_shipping' },
      { label: '小额打款', key: 'all_small_amount_payment' },
      { label: '货损量', key: 'all_loss_num' },
      { label: '货损金额', key: 'all_loss_amount' },
      { label: '异常订单数', key: 'all_abnormal_num' },
      { label: '异常订单额', key: 'all_abnormal_amount' },
      { label: '运费险', key: 'all_freight_insurance' },
    ]
  },
  {
    title: '最终盈利结果',
    color: '#c8443c',
    fields: [
      { label: '报销总额度', key: 'all_reimbursement_amount', dKey: 'reimbursement_amount' },
      { label: '毛利润', key: 'all_total_profit',dKey:'total_profit' },
      { label: '毛利率', key: 'all_total_profit_rate', dKey: 'total_profit_rate' },
    ]
  }
]
const rankConfigFields = rankColumnGroups.reduce((arr, g) => arr.concat(g.fields), [])
export default {
  name: "newUcStatistic",
  data() {
    return {
      rankTabs: [
        { id: 'details', label: '明细数据' },
        { id: 'shop', label: '店铺排行' }
      ],
      rankTab: 'details',
      shopRank:[],
      productList: [],
      visible:false,
      loading:false,
      rangeTime: "",
      startTime: "",
      endTime: "",
      tableData: [],
      statisticData: {},
      searchData: {},
      productInfo: {},
      compare_str: '',

      selectDay: "",
      page_data: {
        page: 1,
        limit: 10,
        total: 0
      },
      data_type_list: [],
      summary:{},
      shopList: [],
      selectShop: '',
      businessList: [],
      selectBusiness: '',
      keysList: [{
        value: 'product_name',
        label: '商品名称',
      }],
      selectKeys: 'product_name',
      keys_input: '',
      timeKeysList: [{
        value: 'pay_time',
        label: '付款时间',
      }],
      selectTimeKeys: 'pay_time',
      columnConfig: {}, // 字段显隐配置 {key: visible}
      rankColumnGroups, // 分组列定义（供模板渲染）
    }
  },
  components: {ColumnConfigDialog},
  computed: {
    ...mapState({
      userinfo: (state) => state.login.userinfo,
    }),
    shopRankCols(){
      let list = rankConfigFields.filter(f => this.columnConfig[f.key] !== false)
      list.unshift({label: '店铺名',key:'shop_name'})
      list.unshift({label:'TOP',key:'ranking'})
      return list
    },
    detailsRankCols(){
      let list = rankConfigFields.filter(f => this.columnConfig[f.key] !== false)
      list.unshift({label: '商品名',key:'name'})
      list.unshift({label: '时间',key:'time_str'})
      list.unshift({label:'序号',key:'index'})
      return list
    },
    isKey() {
      const keys = ['全部销售额', '全部销售单数', '合计毛利润', '合计毛利率', '全店营业额']
      return (label) => keys.includes(label)
    },
    totalPages() {
      return Math.max(1, Math.ceil(this.page_data.total / this.page_data.limit))
    },
    pageNums() {
      const total = this.totalPages
      const nums = []
      const start = Math.max(1, Math.min(this.page_data.page - 2, total - 4))
      for (let i = start; i <= Math.min(total, start + 4); i++) nums.push(i)
      return nums.length ? nums : [1]
    },
    activeStatGroups() {
      const d = this.data_type_list || {}
      const v = (key) => (d[key] !== undefined && d[key] !== null ? d[key] : '--')
      const rate = (key) => this.displayRate(v(key))
      const g = (bar, last, items) => ({ bar, last, title: items.title, desc: items.desc, items: items.items })
      return [
        g('#D4A946', false, {
          title: '营收 & 采购大盘',
          desc: '核心业务规模，先看收入与进货',
          items: [
            { label: '全部销售额', key:'all_sales', mom:'—', up: null },
            { label: '全部销售单数', key:'all_sales_orders', mom: '—', up: null },
            { label: '全部采购量', key:'all_purchase', mom: '—', up: null },
            { label: '全部采购应收', key:'all_purchase_order_amount', mom: '—', up: null },
            { label: '全部采购应付', key:'all_purchase_amount', mom: '—', up: null },
            { label: '全部发货量', key:'all_shipping_num', mom: '—', up: null },
            { label: '全部代发费', key:'all_shipping_fee', mom: '—', up: null },
            { label: '全部达人佣金', key:'all_influencer_commission', mom: '—', up: null },
            { label: '全部权益保险', key:'all_shipping_insurance', mom: '—', up: null },
            { label: '全部千川费用', key:'all_qianchuan_fee', mom: '—', up: null },
          ]
        }),
        g('#4CAF7A', false, {
          title: '售后退款类',
          desc: '退货率 · 发货前后退货量 · 退款金额 · 换货订单',
          items: [
            { label: '全部退货退款量', key:'all_refund_num', mom: '—', up: null },
            { label: '全部退货退款金额', key:'all_refund_fee', mom: '—', up: null },
            { label: '全部退单率', key:'all_return_rate', mom: '—', up: null },
            { label: '仅退款单数', key:'all_refund_only_num', mom: '—', up: null },
            { label: '仅退款金额', key:'all_refund_only_amount', mom: '—', up: null },
            { label: '换货订单量', key:'all_exchange_order_num', mom: '—', up: null },
            { label: '待上游退款金额', key:'all_wait_refund_amount', mom: '—', up: null },

            /* { label: '总退货率', key:'', mom: '—', up: null },
             { label: '发货前仅退货率', key:'', mom: '—', up: null },
             { label: '发货后退货率', key:'', mom: '—', up: null },
             { label: '全部退货量', key:'', mom: '—', up: null },
             { label: '发货前仅退货量', key:'', mom: '—', up: null },
             { label: '发货后退货量', key:'', mom: '—', up: null },
             { label: '发货前仅退款金额', key:'all_refund_only_amount', mom: '—', up: null },
             { label: '发货后退货金额', key:'', mom: '—', up: null },
             { label: '发货前仅退款单数', key:'all_refund_only_num', mom: '—', up: null },
             { label: '发货前仅退款率', key:'all_refund_only_amount', mom: '—', up: null },*/
          ]
        }),
        g('#3FB6E0', false, {
          title: '平台费用 & 赔付杂费',
          desc: '各类扣点、罚款、运费成本',
          items: [
            { label: '全部平台服务费', key:'all_shop_service_fee', mom: '—', up: null },
            { label: '全部消费者赔付', key:'all_timeout_compensation', mom: '—', up: null },
            { label: '全部判罚扣款', key:'all_violation_compensation', mom: '—', up: null },
            { label: '全部评价有礼', key:'all_evaluate_fee', mom: '—', up: null },
            { label: '上门取件运费', key:'all_pick_up_shipping', mom: '—', up: null },
            { label: '全部小额打款', key:'all_small_amount_payment', mom: '—', up: null },
            { label: '货损量', key:'all_damaged_goods_num', mom: '—', up: null },
            { label: '货损金额', key:'all_damaged_goods_amount', mom: '—', up: null },
            { label: '异常单数量', key:'all_abnormal_order_num', mom: '—', up: null },
            { label: '异常单金额', key:'all_abnormal_order_amount', mom: '—', up: null },
          ]
        }),
        g('#E85D5D', true, {
          title: '最终盈利结果',
          desc: '报表收尾，利润核心指标',
          items: [
            { label: '报销总金额', key:'all_reimbursement_amount', mom: '—', up: null },
            { label: '合计毛利润', key:'all_total_profit', mom: '—', up: null },
            { label: '合计毛利率', key:'all_profit_rate', mom: '—', up: null }
          ]
        })
      ]
    },
    columnNum() {
      return rankConfigFields.filter(f => this.columnConfig[f.key] !== false).length
    },
  },
  created() {
    this.initColumnConfig()
  },
  beforeDestroy() {
    clearInterval(this.refreshTimer)
  },
  methods: {
    ...mapActions({
      getStatisticProductDetailData: "ucenter_order/opGetStatisticProductDetailData",
      getStatisticShopProductRanking: "ucenter_order/opGetStatisticShopProductRanking",
      getStatisticProductList: "ucenter_order/opGetStatisticProductList",
    }),

    show(goodsId){
      this.searchData.goods_id = goodsId
      this.index()
      this.getProductList()
      this.refreshTimer = setInterval(() => {
        this.index()
      }, 5000);
    },
    close(){
      clearInterval(this.refreshTimer)
      this.visible =false
    },
    displayValue(value) {
      return value === undefined || value === null || value === '' ? '--' : value
    },
    displayRate(value) {
      const result = this.displayValue(value)
      return result === '--' || String(result).includes('%') ? result : `${result}%`
    },
    switchRank(id) {
      this.rankTab = id
      this.loadRank(1)
    },
    changeShop() {
      this.searchData.shop_id = this.selectShop
      this.getRanking()
      this.index()
    },
    changeBusiness() {
      this.searchData.business_user_id = this.selectBusiness
      this.getRanking()
      this.index()
    },

    index() {
      let params = {
        page: this.page,
        page_size: this.page_size,
      }
      params = Object.assign(params, this.searchData)
      this.getStatisticProductDetailData({
        data: params,
        success: (res) => {
          if (res.code === 200) {
            this.data_type_list = res.data.list
            this.shopList = res.data.shop_list
            this.businessList = res.data.business_user_list
            this.productInfo = res?.data?.productInfo ?? {}
            const summary = {}
            const list = this.data_type_list && Array.isArray(this.data_type_list) ? this.data_type_list : []
            list.forEach((item) => {
              if (item && item.key) summary[item.key] = item
            })
            this.summary = summary
          } else {
            this.$message({message: res.msg, type: 'error',});
          }
        }
      })
    },
    loadRank(n){
      this.page_data.page = n
      if (this.rankTab == 'details') {
        this.getProductList()
      } else {
        this.getRanking();
      }
    },
    // 店铺排行
    getRanking() {
      let params = {
        limit: this.page_data.limit,
        page: this.page_data.page,
        type: this.rank_type,
        keys: this.selectKeys,
        keys_input: this.keys_input
      }
      Object.assign(params, this.searchData)
      this.loading = true
      this.getStatisticShopProductRanking({
        data: params,
        success: (res) => {
          if (res.code === 200) {
            this.shopRank = res.data.list.data
            this.page_data.total = res.data.list.total
          } else {
            this.$message({message: res.msg, type: 'error',});
          }
          this.loading = false
        }
      })
    },
    //明细数据
    getProductList() {
      let params = {
        limit: this.page_data.limit,
        page: this.page_data.page,
        type: this.rank_type,
        keys: this.selectKeys,
        keys_input: this.keys_input
      }
      Object.assign(params, this.searchData)
      this.loading = true
      this.getStatisticProductList({
        data: params,
        success: (res) => {
          if (res.code == 200) {
            this.productList = res.data.list.data
            this.page_data.total = res.data.list.total
          } else {
            this.$message({message: res.msg, type: 'error',});
          }
          this.loading = false
        }
      })
    },
    resetSearch() {
      this.selectDay = ''
      this.searchData.start_time = ''
      this.searchData.end_time = ''
      this.searchData.shop_id = ''
      this.searchData.business_user_id = ''
      this.searchData.select_day = ''
      this.index()
      this.loadRank(1)
    },
    changeDate() {
      if (this.selectDay) {
        this.searchData.start_time = this.selectDay[0];
        this.searchData.end_time = this.selectDay[1]
        this.searchData.select_day = ''
      }
      this.index()
      this.loadRank(1)
    },

    selection(selection) {
      this.ids = selection.map(item => item.id)
      this.single = selection.length == 0
    },
    copyText(text) {
      var input = document.createElement("input"); // 创建input对象
      input.value = text; // 设置复制内容
      document.body.appendChild(input); // 添加临时实例
      input.select(); // 选择实例内容
      document.execCommand("Copy"); // 执行复制
      document.body.removeChild(input); // 删除临时实例
      this.$message({
        message: '复制成功',
        type: 'success'
      });

    },

    /**
     * —— 数据配置 —— */
    // 初始化列显隐配置：默认全部显示
    initColumnConfig() {
      const cfg = {}
      rankConfigFields.forEach(f => { cfg[f.key] = true })
      this.columnConfig = cfg
    },
    changeColumnConfig(e){
      this.columnConfig = e
    },
    // 打开数据配置弹窗：将当前配置拷贝给临时配置
    openConfig() {
      this.$refs.columnConfigRef.open()
    },

  }
}

</script>

<style scoped>
.gx-sd__card{
  background: rgb(255, 255, 255);
  border-radius: 8px;
  border: 2px solid rgb(224, 224, 236);
  padding: 14px 16px;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  gap: 14px;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 1px 4px;
}
.gx-sd__card-img{
  width: 64px;
  height: 64px;
  border-radius: 8px;
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 205, 210);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  flex-shrink: 0;
}
.gx-sd__card-img img{
  width: 100%;
  height: 100%;
  border-radius: 8px;
}
.gx-sd__goods{
  flex: 1;
  min-width: 0;
}
.gx-sd__goods-title{
  font-size: 14px;
  font-weight: 600;
  color: rgb(26, 26, 46);
  margin-bottom: 6px;
  line-height: 1.4;
}
.gx-sd__goods-info{
  display: flex; align-items: center; gap: 14px; flex-wrap: wrap;
}
.gx-sd__goods-price{
  font-size: 15px; font-weight: 700; color: rgb(200, 68, 60);
}
.gx-sd__goods-label--153{
  font-size: 11px; color: rgb(153, 153, 153);
}
.gx-sd__goods-label--102{
  font-size: 11px; color: rgb(102, 102, 102);
}
.gx-sd__goods-line{
  width: 1px; height: 14px; background: rgb(224, 224, 236); flex-shrink: 0;
}
.gx-sd__opts{
  display: flex; gap: 8px;
}
.gx-sd__opts-btn{
  height: 30px;
  padding: 0px 12px;
  border-radius: 4px;
  cursor: pointer;
  background: rgb(255, 255, 255);
  border: 2px solid rgb(224, 224, 236);
  font-size: 12px;
  color: rgb(102, 102, 102);
  display: flex;
  align-items: center; gap: 5px;
}
.gx-sd__opts-btn--info:hover{
  border: 2px solid rgb(200,68,60);
  color: rgb(200,68,60);
}
.gx-sd__opts-btn--danger{
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 205, 210);
  color: rgb(200, 68, 60);
}
.gx-sd__filter {
  background: rgb(255, 255, 255);
  border-radius: 8px;
  border: 2px solid rgb(224, 224, 236);
  padding: 10px 14px;
  margin-bottom: 12px;
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  align-items: center;
  box-shadow: rgba(0, 0, 0, 0.04) 0px 1px 3px;
}

.gx-sd__board {
  background: #FFFFFF;
  border-radius: 8px;
  border: 2px solid #E0E0EC;
  margin-bottom: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .06);
  overflow: hidden;
}
.gx-sd__board-head {
  padding: 10px 14px 4px;
  border-bottom: 1px solid rgb(224, 224, 236);
  background: rgb(238, 241, 246);
  padding: 10px 14px 4px;
  border-bottom: 1px solid rgb(224, 224, 236);
  background: rgb(238, 241, 246);
}

.gx-sd__board-body {
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.gx-sd__grp-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 7px;
}
.gx-sd__grp-bar {
  width: 3px;
  height: 13px;
  border-radius: 2px;
  flex-shrink: 0;
}
.gx-sd__grp-title {
  font-size: 12px;
  font-weight: 600;
  color: #1A1A2E;
}
.gx-sd__grp-desc {
  font-size: 11px;
  color: #4A4A6A;
}
.gx-sd__grp-items {
  display: grid;
  gap: 6px;
}
.gx-sd__item {
  border-radius: 6px;
  padding: 9px 10px 8px;
  background: rgba(212, 169, 70, .1);
  border-color: rgba(212, 169, 70, .3);
}
.gx-sd__item--last {
  padding: 14px 16px 12px;
}
.gx-sd__item--key {
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 205, 210);
  box-shadow: 0 2px 8px #E1E5EE;
}
.gx-sd__item-label {
  font-size: 10px;
  color: #4A4A6A;
  margin-bottom: 4px;
  line-height: 1.3;
  min-height: 24px;
}
.gx-sd__item--last .gx-sd__item-label {
  font-size: 11px;
  min-height: 0;
}
.gx-sd__item-value {
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  font-weight: 700;
  color: #1A1A2E;
  line-height: 1;
}
.gx-sd__item--last .gx-sd__item-value {
  font-size: 20px;
}
.gx-sd__item--key .gx-sd__item-value {
  font-size: 15px;
  color: #D4A946;
}
.gx-sd__item-mom {
  font-size: 10px;
  color: #999;
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 2px;
}
.gx-sd__mom-arrow {
  font-size: 8px;
  color: #52C41A;
}
.gx-sd__mom-arrow--down {
  color: #C8443C;
}
.gx-sd__rank {
  background: #FFFFFF;
  border-radius: 8px;
  border: 2px solid #E0E0EC;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .06);
}
.gx-sd__rank-search{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.gx-sd__rank-tabs {
  display: flex;
  border-bottom: 1px solid #E0E0EC;
  align-items: center;
}
.gx-sd__rank-tab {
  padding: 10px 22px;
  border: none;
  cursor: pointer;
  font-size: 13px;
  background: #F5F0E8;
  color: #666;
  border-bottom: 2px solid transparent;
  transition: all .15s;
}
.gx-sd__rank-tab--on {
  background: #fff;
  color: #C8443C;
  font-weight: 600;
  border-bottom-color: #C8443C;
}

.gx-sd__ran-filter{
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 9px 14px;
  border-bottom: 1px solid rgb(224, 224, 236);
  background: rgb(238, 241, 246);
  flex-wrap: wrap;
}
.btn-config{
  display: flex;
  align-items: center;
  gap: 5px;
  border-radius: 4px;
}
.btn-config:hover{
  background: rgb(255,245,245);
  border: 1px solid var(--gx-red);
  color: var(--gx-red);
}
.column-Num{
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: rgb(200, 68, 60);
  font-family: "JetBrains Mono", monospace;
  font-size: 9px;
  font-weight: 700;
  color: rgb(255, 255, 255);
}
.gx-sd__table {
  overflow-x: auto;
}
.gx-sd__table table {
  width: 100%;
  border-collapse: collapse;
  white-space: nowrap;
}
.gx-sd__table th {
  padding: 10px 14px;
  text-align: left;
  background: #EEF1F6;
  font-size: 11px;
  font-weight: 500;
  color: #606266;
  border-bottom: 1px solid #E0E0EC;
  letter-spacing: .04em;
}
.gx-sd__table td {
  padding: 10px 14px;
  font-size: 12px;
  color: #1A1A2E;
  border-top: 1px solid #f5f5f5;
}
.gx-sd__table tr:hover td {
  background: #F5F0E8;
}
.gx-sd__table::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
.gx-sd__table::-webkit-scrollbar-thumb {
  background: rgba(212, 169, 70, .35);
  border-radius: 2px;
}
.gx-sd__table::-webkit-scrollbar-track {
  background: #F4F6F8;
}
.gx-sd__mono {
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
}
.gx-sd__dim {
  color: #6A6A8A;
}
.gx-sd__red {
  font-weight: 600;
  color: rgb(200, 68, 60)
}
.gx-sd__green{
  color: rgb(82, 196, 26)
}
.gx-sd__rank-no {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: rgb(245, 245, 245);
  font-size: 11px;
  font-weight: 700;
  color: #999999;
}
.gx-sd__rank-no--one{
  font-size: 14px;
  background: rgb(255, 215, 0);
  color: rgb(255, 255, 255);
}
.gx-sd__rank-no--two{
  font-size: 14px;
  background: rgb(192,192,192);
  color: rgb(255, 255, 255);
}
.gx-sd__rank-no--three{
  background: rgb(205, 127, 50);
  color: rgb(255, 255, 255);
}
.gx-sd__shop-name {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: rgb(26, 26, 46);
  font-weight: 500;
}
.gx-sd__shop-name-icon{
  width: 24px;
  height: 24px;
  border-radius: 5px;
  background: rgb(255, 245, 245);
  border: 1px solid rgb(255, 205, 210);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Noto Serif SC", serif;
  font-size: 11px;
  font-weight: 700;
  color: rgb(200, 68, 60);
  flex-shrink: 0;
}

.gx-sd__empty {
  text-align: center;
  padding: 52px 0 !important;
  color: #6A6A8A;
}
.gx-sd__pager {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  border-top: 1px solid #E0E0EC;
  background: #eef1f6;
}
.gx-sd__pager-total {
  font-size: 11px;
  color: #999999;
}
.gx-sd__pager-btns {
  display: flex;
  gap: 5px;
}
.gx-sd__page {
  min-width: 28px;
  height: 26px;
  padding: 0 8px;
  border-radius: 4px;
  border: 1px solid #E0E0EC;
  background: #FFFFFF;
  cursor: pointer;
  font-family: 'JetBrains Mono', monospace;
  font-size: 11px;
  color: #4A4A6A;
}
.gx-sd__page:disabled {
  opacity: .5;
  cursor: not-allowed;
}
.gx-sd__page--on {
  border: 1px solid rgb(200, 68, 60);
  background: rgb(255, 245, 245);
  color:rgb(200, 68, 60);
  font-weight: 700;
}
@media (max-width: 1200px) {
  .gx-sd__grp-items {
    grid-template-columns: repeat(5, 1fr) !important;
  }
}
</style>
